import React from 'react'
import { makeStyles } from '@material-ui/core'
import RenderEmptyState from 'empty-states'
import { Button, Icon } from 'foundations-library/components'

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 600,
        width: '100%',
        marginTop: 50
    }
})

interface Props {
    onCreate: () => void
}

/**
 * Introduces Live Receptionist before the first script is created.
 */
const ScriptsEmptyState = ({ onCreate }: Props): JSX.Element => {
    const styles = useStyles()

    return <div className={styles.root}>
        <RenderEmptyState
            svg={{ name: 'calls-3', styles: { width: 430, maxWidth: '100%', height: 'auto' } }}
            rootStyles={{ maxWidth: 800, gap: 50 }}
            contentStyles={{ gap: 20 }}
            buttonContainerStyles={{ padding: '20px 0 0' }}
            title={{ text: 'Create a script for Live Receptionist', variant: 'h5', color: 'black' }}
            description={{
                text: 'Give every caller the personal touch of a real person! Our friendly, US-based live receptionists ' +
                    'are available 24/7 to answer calls, assist customers, and schedule appointments with genuine care ' +
                    'and understanding—so you never miss an opportunity to make a great impression.',
                variant: 'body1',
                color: 'black'
            }}
            buttons={[
                <Button
                    key='create-script'
                    variant='contained'
                    color='primary'
                    size='large'
                    iconLeft
                    icon={<Icon
                        name='add'
                        size={20}
                        color='white'
                        className='button__icon button__icon-left'
                        style={{ marginRight: 4 }}
                    />}
                    onClick={onCreate}
                >
                    Create Script
                </Button>
            ]}
        />
    </div>
}

export default ScriptsEmptyState
